
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3011',
  depVersions: {
  "customer-portal-app": "static-1.3011",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9902",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26069",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5841",
  "hs-test-utils": "static-1.8273",
  "hub-http": "static-1.6458",
  "hub-http-shared-msw-handlers": "static-1.10523",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18866",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11730",
  "I18n": "static-7.1661",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6694",
  "payment-link-components": "static-1.24074",
  "portals-platform-bend-plugin": "static-1.17",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7364",
  "quartz-core": "static-1.6583",
  "quartz-i18n": "static-1.1039",
  "react": "static-7.190",
  "react-colorpicker": "static-2.10453",
  "react-dlb": "static-1.84",
  "react-utils": "static-2.5514",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20233",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18318",
  "ui-components-test-utils": "static-1.5867",
  "UIComponents": "static-3.8676",
  "foundations-assets": "static-1.5122",
  "foundations-components": "static-1.8381",
  "foundations-theming": "static-1.4700",
  "foundations-theming-specialty": "static-1.2416",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1353",
  "quartz-config": "static-1.1142",
  "quartz-routing": "static-1.794",
  "quick-fetch": "static-1.4092",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16954",
  "rpc-client-utils": "static-1.4909",
  "sanitize-text": "static-1.8396",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5002",
  "ui-addon-react-router-dom": "static-1.9779",
  "usage-tracker": "static-1.7602",
  "usage-tracker-anonymous": "static-1.6019",
  "usage-tracker-core": "static-1.7452",
  "video-components-external": "static-1.12051",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3575",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3641",
  "quartz-webpack": "static-1.3588",
  "bend-plugin-quartz-routing": "static-1.442",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7933",
  "frontend-preferences-client": "static-1.8173",
  "laboratory-lib": "static-3.7398",
  "onboarding-scopes": "static-1.6704",
  "seat-types-lib": "static-1.605",
  "ui-addon-opt": "static-4.8609",
  "HeadJS": "static-2.789",
  "hs-test-utils-bend-plugin": "static-1.3384",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.255",
  "ts-schema": "static-1.4254",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8129",
  "content-media-capture": "static-1.5303",
  "cssUtils": "static-1.869",
  "customer-data-ui-utilities": "static-1.10072",
  "file-manager-components": "static-1.24357",
  "HubStyle": "static-2.12037",
  "knowledge-content-types": "static-1.8618",
  "PatternValidationJS": "static-1.3143",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.495",
  "ui-addon-emoji-picker": "static-1.10132",
  "ui-addon-i18n": "static-1.11391",
  "ui-business-units-lib": "static-1.9327",
  "ui-shepherd-react": "static-3.10509",
  "video-data-lib": "static-1.35709",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4564",
  "commerce-tours-lib": "static-1.6533",
  "customer-data-properties": "static-1.52423",
  "getting-started-shared-tasks": "static-1.19109",
  "growth-onboarding-reliability": "static-1.5325",
  "onboarding-tours": "static-1.17036",
  "reference-resolvers-lite": "static-1.8346",
  "sales-checkout-service-client": "static-1.3779",
  "ui-addon-iframeable": "static-1.9323",
  "user-context": "static-1.5358",
  "bender-build-tools": "static-1.3373",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4824",
  "icons": "static-2.674",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1039",
  "quartz-head": "static-1.1029",
  "quartz-test": "static-1.1039",
  "quartz-tracking": "static-1.743",
  "trellis-components": "static-1.2480",
  "ui-fonts": "static-1.992",
  "usage-tracker-container": "static-1.7592",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9672",
  "data-token-picker": "static-1.16813",
  "FileManagerLib": "static-1.39997",
  "property-translator": "static-1.5640",
  "atom": "static-1.5328",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6280",
  "salesImages": "static-1.530",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5864",
  "react-create-root-preference": "static-1.60",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1229",
  "bend-plugin-foundations-components": "static-1.4650",
  "floating-ui": "static-1.61",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2461",
  "bend-plugin-foundations-theming": "static-1.3183",
  "foundations-theming-base": "static-1.3685",
  "stylex": "static-1.38",
  "interframe": "static-3.5003",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6016",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.319",
  "chirp-fetch": "static-1.2135",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4722",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4903",
  "content-media-composition-data-lib": "static-1.13107",
  "content-media-compositions": "static-2.17114",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4398",
  "magpie-lib": "static-1.5718",
  "magpie-types": "static-1.5178",
  "media-bridge-lib": "static-1.19334",
  "inbound-db-properties-service-client": "static-1.4018",
  "superstore": "static-1.5003",
  "feedback-loader": "static-1.29733",
  "ai-components-ui-library": "static-1.9579",
  "ui-addon-video-player": "static-1.8951",
  "ui-coaching-tips": "static-1.29210",
  "ContentUtils": "static-1.69052",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4670",
  "sassPrefix": "static-1.161",
  "react-dnd-compat": "static-1.4862",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1562",
  "copilot-toolkit": "static-1.11740",
  "avatar-components": "static-1.2743",
  "navigation-messaging": "static-1.8037",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8428",
  "commerce-products-lib": "static-1.10402",
  "crm-message-bus": "static-1.43635",
  "growth-data-modal": "static-1.5816",
  "hubspot-apollo-client": "static-1.5124",
  "onboarding-tours-client": "static-1.5250",
  "batch-promise": "static-1.1791",
  "calling-global-api": "static-1.65362",
  "calling-internal-common": "static-1.31562",
  "calling-lifecycle-internal": "static-1.66744",
  "calling-lifecycle-messages": "static-1.59038",
  "conditional-properties-service-client": "static-1.3974",
  "crm-index-visualization-core": "static-1.4472",
  "crm-links": "static-1.6569",
  "crm-pipelines-api-client-types": "static-1.4307",
  "customer-data-objects-ui-components": "static-1.13277",
  "customer-data-properties-shared-msw-handlers": "static-1.9850",
  "customer-data-property-utils": "static-1.8345",
  "external-options-client-types": "static-1.4301",
  "formula-editor": "static-1.14673",
  "framework-data-schema-resolvers": "static-1.7139",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.434",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4386",
  "meetings-icalendar-utils-lib": "static-1.882",
  "multi-currency-client-types": "static-1.3868",
  "object-builder-ui-client": "static-1.49523",
  "pipeline-validation-client-types": "static-1.4143",
  "property-value-citations": "static-1.3037",
  "pulse": "static-1.873",
  "smart-property-lib": "static-1.8163",
  "tiered-pricing": "static-1.1856",
  "trial-components-library": "static-1.14019",
  "topics-actions-lib": "static-1.405",
  "ui-addon-form-validation": "static-1.11232",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3306",
  "growth-onboarding-next-action-utils": "static-1.2592",
  "navigation-components": "static-1.18710",
  "onboarding-tours-utils": "static-1.1102",
  "ui-shepherd-tracker": "static-1.7890",
  "ui-universal-auth": "static-1.9282",
  "getting-started-shared-tasks-store": "static-1.18227",
  "hubspotter-http-shared-msw-handlers": "static-1.10521",
  "usage-tracker-session-replay": "static-1.5288",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1207",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6271",
  "FileManagerCore": "static-1.39856",
  "FileManagerImages": "static-1.37508",
  "video-components": "static-1.14053",
  "foundations-components-legacy": "static-1.1406",
  "purchase-motions-api": "static-1.6283",
  "signup-constants": "static-1.19487",
  "signup-ui-url-generator": "static-2.8306",
  "usage-tracker-public": "static-1.7413",
  "reactive-lib": "static-1.967",
  "simple-logging-lib": "static-1.3295",
  "chatspot-core": "static-1.22625",
  "growth-onboarding-feedback-components": "static-1.6829",
  "cms-field-types": "static-1.5061",
  "content-icons-ui": "static-1.2310",
  "integrations-lib": "static-1.16923",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.540",
  "breeze-engine-core": "static-1.840",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1023",
  "customer-data-tracking": "static-1.7128",
  "products-iframe-lib": "static-1.8493",
  "products-ui-components-shared-msw-handlers": "static-1.10905",
  "restore-request-side-panel-lib": "static-1.1549",
  "onboarding-data-sync-lib": "static-1.2395",
  "hubspot-apollo-cache": "static-1.583",
  "calling-error-reporting": "static-1.31569",
  "shared-worker-versioning": "static-1.11287",
  "calling-usage-tracker": "static-1.6785",
  "voice-sms-access-library": "static-1.1903",
  "conversations-skeleton-state": "static-1.7495",
  "crm-index-associations-lib": "static-1.6688",
  "framework-data-schema-quick-fetch": "static-1.7044",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10606",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4504",
  "location-customization-utils-lib": "static-1.9986",
  "bark-lib": "static-1.16751",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6136",
  "react-codemirror": "static-1.10886",
  "fdsr-migration-layer": "static-1.258",
  "framework-builder-read-service-client": "static-1.4181",
  "persist-promise": "static-1.3948",
  "event-emitter": "static-1.1200",
  "bend-plugin-pulse": "static-1.376",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.572",
  "fsm": "static-1.3985",
  "policy-lib": "static-1.7040",
  "react-tinymce": "static-1.55871",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10669",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54997",
  "tinymce-plugins": "static-1.58111",
  "tinymce-themes": "static-1.56967",
  "embedded-academy-lib": "static-1.15339",
  "hubs-service-types": "static-1.1503",
  "growth-onboarding-next-action-components": "static-1.2620",
  "user-context-client": "static-1.4754",
  "nest": "static-1.483",
  "unified-auth-core-lib": "static-1.1078",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.179",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4779",
  "video-embed": "static-1.36543",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.360",
  "integrations-error-boundary-lib": "static-1.14338",
  "integrations-tracking-lib": "static-1.5854",
  "native-integrations-shared-strings": "static-1.8023",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10612",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.796",
  "InboxConnectUtils": "static-4.15455",
  "meetings-connect-utils-lib": "static-1.7854",
  "calling-orchestration-schema": "static-1.36680",
  "crm-record-cards-service-types": "static-1.3756",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16262",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4756",
  "storybook-react": "static-1.37",
  "hub-http-contrib": "static-1.3285",
  "tinymce-data": "static-1.41082",
  "ui-addon-sales-email": "static-1.5459",
  "layout-dnd-components": "static-1.12890",
  "layout-dnd-utils": "static-1.11865",
  "ui-brand-identity-lib": "static-1.16215",
  "NamespacedHubStyle": "static-2.9223",
  "academy-common-lib": "static-1.14799",
  "outpost": "static-1.4407",
  "universal-page-editor-lib": "static-1.3256",
  "adobe-sign-auth-lib": "static-1.349",
  "ads-unified-auth-lib": "static-1.1027",
  "google-sheets-integration-lib": "static-1.925",
  "microsoft-drive-auth-lib": "static-1.15",
  "surveymonkey-integration-lib": "static-1.370",
  "slack-ui-library": "static-1.10642",
  "ContentData": "static-1.69127",
  "layout-data-lib": "static-1.10190",
  "academy-service-client": "static-1.3936",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4650",
  "trellis-ecosystem": "static-1.7554",
  "wootric-nps": "static-1.7160",
  "advanced-menus-core": "static-1.15510",
  "advanced-menus-lib": "static-1.12391",
  "ExportDialog": "static-6.10626",
  "ui-memberships-settings-lib": "static-1.34705",
  "marketplace-ui-apps-core": "static-1.19126",
  "marketplace-ui-common": "static-1.20594",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15509",
  "simple-menus-lib": "static-1.17026",
  "developer-experience-shared-components": "static-1.10746",
  "immutable-less": "static-1.4896",
  "marketplace-ui-client-types": "static-1.18001",
  "ui-addon-integrations-directory-panel": "static-2.8272",
  "ui-extensibility-client-types": "static-1.4166",
  "ai-settings-ui-library": "static-1.8253",
  "nav-meta": "static-1.30347",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.879",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4501",
  "simple-data-table": "static-1.3433"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3011",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9902",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26069",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5841",
  "hs-test-utils": "/hs-test-utils/static-1.8273",
  "hub-http": "/hub-http/static-1.6458",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10523",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18866",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11730",
  "I18n": "/I18n/static-7.1661",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6694",
  "payment-link-components": "/payment-link-components/static-1.24074",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.17",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7364",
  "quartz-core": "/quartz-core/static-1.6583",
  "quartz-i18n": "/quartz-i18n/static-1.1039",
  "react": "/react/static-7.190",
  "react-colorpicker": "/react-colorpicker/static-2.10453",
  "react-dlb": "/react-dlb/static-1.84",
  "react-utils": "/react-utils/static-2.5514",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20233",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18318",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5867",
  "UIComponents": "/UIComponents/static-3.8676",
  "foundations-assets": "/foundations-assets/static-1.5122",
  "foundations-components": "/foundations-components/static-1.8381",
  "foundations-theming": "/foundations-theming/static-1.4700",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2416",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1353",
  "quartz-config": "/quartz-config/static-1.1142",
  "quartz-routing": "/quartz-routing/static-1.794",
  "quick-fetch": "/quick-fetch/static-1.4092",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16954",
  "rpc-client-utils": "/rpc-client-utils/static-1.4909",
  "sanitize-text": "/sanitize-text/static-1.8396",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5002",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9779",
  "usage-tracker": "/usage-tracker/static-1.7602",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6019",
  "usage-tracker-core": "/usage-tracker-core/static-1.7452",
  "video-components-external": "/video-components-external/static-1.12051",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3575",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3641",
  "quartz-webpack": "/quartz-webpack/static-1.3588",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.442",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7933",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8173",
  "laboratory-lib": "/laboratory-lib/static-3.7398",
  "onboarding-scopes": "/onboarding-scopes/static-1.6704",
  "seat-types-lib": "/seat-types-lib/static-1.605",
  "ui-addon-opt": "/ui-addon-opt/static-4.8609",
  "HeadJS": "/HeadJS/static-2.789",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3384",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.255",
  "ts-schema": "/ts-schema/static-1.4254",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8129",
  "content-media-capture": "/content-media-capture/static-1.5303",
  "cssUtils": "/cssUtils/static-1.869",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10072",
  "file-manager-components": "/file-manager-components/static-1.24357",
  "HubStyle": "/HubStyle/static-2.12037",
  "knowledge-content-types": "/knowledge-content-types/static-1.8618",
  "PatternValidationJS": "/PatternValidationJS/static-1.3143",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10132",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11391",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9327",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10509",
  "video-data-lib": "/video-data-lib/static-1.35709",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4564",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6533",
  "customer-data-properties": "/customer-data-properties/static-1.52423",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19109",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5325",
  "onboarding-tours": "/onboarding-tours/static-1.17036",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8346",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9323",
  "user-context": "/user-context/static-1.5358",
  "bender-build-tools": "/bender-build-tools/static-1.3373",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4824",
  "icons": "/icons/static-2.674",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1039",
  "quartz-head": "/quartz-head/static-1.1029",
  "quartz-test": "/quartz-test/static-1.1039",
  "quartz-tracking": "/quartz-tracking/static-1.743",
  "trellis-components": "/trellis-components/static-1.2480",
  "ui-fonts": "/ui-fonts/static-1.992",
  "usage-tracker-container": "/usage-tracker-container/static-1.7592",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9672",
  "data-token-picker": "/data-token-picker/static-1.16813",
  "FileManagerLib": "/FileManagerLib/static-1.39997",
  "property-translator": "/property-translator/static-1.5640",
  "atom": "/atom/static-1.5328",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6280",
  "salesImages": "/salesImages/static-1.530",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5864",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1229",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4650",
  "floating-ui": "/floating-ui/static-1.61",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2461",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3183",
  "foundations-theming-base": "/foundations-theming-base/static-1.3685",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5003",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6016",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.319",
  "chirp-fetch": "/chirp-fetch/static-1.2135",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4722",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4903",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13107",
  "content-media-compositions": "/content-media-compositions/static-2.17114",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4398",
  "magpie-lib": "/magpie-lib/static-1.5718",
  "magpie-types": "/magpie-types/static-1.5178",
  "media-bridge-lib": "/media-bridge-lib/static-1.19334",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4018",
  "superstore": "/superstore/static-1.5003",
  "feedback-loader": "/feedback-loader/static-1.29733",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9579",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8951",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29210",
  "ContentUtils": "/ContentUtils/static-1.69052",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4670",
  "sassPrefix": "/sassPrefix/static-1.161",
  "react-dnd-compat": "/react-dnd-compat/static-1.4862",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1562",
  "copilot-toolkit": "/copilot-toolkit/static-1.11740",
  "avatar-components": "/avatar-components/static-1.2743",
  "navigation-messaging": "/navigation-messaging/static-1.8037",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8428",
  "commerce-products-lib": "/commerce-products-lib/static-1.10402",
  "crm-message-bus": "/crm-message-bus/static-1.43635",
  "growth-data-modal": "/growth-data-modal/static-1.5816",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5124",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5250",
  "batch-promise": "/batch-promise/static-1.1791",
  "calling-global-api": "/calling-global-api/static-1.65362",
  "calling-internal-common": "/calling-internal-common/static-1.31562",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66744",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59038",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3974",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4472",
  "crm-links": "/crm-links/static-1.6569",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4307",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13277",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9850",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8345",
  "external-options-client-types": "/external-options-client-types/static-1.4301",
  "formula-editor": "/formula-editor/static-1.14673",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7139",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.434",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4386",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.882",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3868",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49523",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4143",
  "property-value-citations": "/property-value-citations/static-1.3037",
  "pulse": "/pulse/static-1.873",
  "smart-property-lib": "/smart-property-lib/static-1.8163",
  "tiered-pricing": "/tiered-pricing/static-1.1856",
  "trial-components-library": "/trial-components-library/static-1.14019",
  "topics-actions-lib": "/topics-actions-lib/static-1.405",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11232",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3306",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2592",
  "navigation-components": "/navigation-components/static-1.18710",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1102",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7890",
  "ui-universal-auth": "/ui-universal-auth/static-1.9282",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18227",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10521",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5288",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1207",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6271",
  "FileManagerCore": "/FileManagerCore/static-1.39856",
  "FileManagerImages": "/FileManagerImages/static-1.37508",
  "video-components": "/video-components/static-1.14053",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1406",
  "purchase-motions-api": "/purchase-motions-api/static-1.6283",
  "signup-constants": "/signup-constants/static-1.19487",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8306",
  "usage-tracker-public": "/usage-tracker-public/static-1.7413",
  "reactive-lib": "/reactive-lib/static-1.967",
  "simple-logging-lib": "/simple-logging-lib/static-1.3295",
  "chatspot-core": "/chatspot-core/static-1.22625",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6829",
  "cms-field-types": "/cms-field-types/static-1.5061",
  "content-icons-ui": "/content-icons-ui/static-1.2310",
  "integrations-lib": "/integrations-lib/static-1.16923",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.540",
  "breeze-engine-core": "/breeze-engine-core/static-1.840",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1023",
  "customer-data-tracking": "/customer-data-tracking/static-1.7128",
  "products-iframe-lib": "/products-iframe-lib/static-1.8493",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10905",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1549",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2395",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.583",
  "calling-error-reporting": "/calling-error-reporting/static-1.31569",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11287",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6785",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1903",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7495",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6688",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7044",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10606",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4504",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9986",
  "bark-lib": "/bark-lib/static-1.16751",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6136",
  "react-codemirror": "/react-codemirror/static-1.10886",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.258",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4181",
  "persist-promise": "/persist-promise/static-1.3948",
  "event-emitter": "/event-emitter/static-1.1200",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.376",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.572",
  "fsm": "/fsm/static-1.3985",
  "policy-lib": "/policy-lib/static-1.7040",
  "react-tinymce": "/react-tinymce/static-1.55871",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10669",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54997",
  "tinymce-plugins": "/tinymce-plugins/static-1.58111",
  "tinymce-themes": "/tinymce-themes/static-1.56967",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15339",
  "hubs-service-types": "/hubs-service-types/static-1.1503",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2620",
  "user-context-client": "/user-context-client/static-1.4754",
  "nest": "/nest/static-1.483",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1078",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.179",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4779",
  "video-embed": "/video-embed/static-1.36543",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.360",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14338",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5854",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8023",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10612",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.796",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15455",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7854",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36680",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3756",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16262",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4756",
  "storybook-react": "/storybook-react/static-1.37",
  "hub-http-contrib": "/hub-http-contrib/static-1.3285",
  "tinymce-data": "/tinymce-data/static-1.41082",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5459",
  "layout-dnd-components": "/layout-dnd-components/static-1.12890",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11865",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16215",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9223",
  "academy-common-lib": "/academy-common-lib/static-1.14799",
  "outpost": "/outpost/static-1.4407",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3256",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.349",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1027",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.925",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.15",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.370",
  "slack-ui-library": "/slack-ui-library/static-1.10642",
  "ContentData": "/ContentData/static-1.69127",
  "layout-data-lib": "/layout-data-lib/static-1.10190",
  "academy-service-client": "/academy-service-client/static-1.3936",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4650",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7554",
  "wootric-nps": "/wootric-nps/static-1.7160",
  "advanced-menus-core": "/advanced-menus-core/static-1.15510",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12391",
  "ExportDialog": "/ExportDialog/static-6.10626",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34705",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19126",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20594",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15509",
  "simple-menus-lib": "/simple-menus-lib/static-1.17026",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10746",
  "immutable-less": "/immutable-less/static-1.4896",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18001",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8272",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4166",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8253",
  "nav-meta": "/nav-meta/static-1.30347",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.879",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4501",
  "simple-data-table": "/simple-data-table/static-1.3433"
}
};
